import { ChangeDetectorRef, Component, OnInit, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { MatPaginator, MatTableDataSource } from '@angular/material';
import { Observable } from 'rxjs';
import { SubmitdataService } from 'src/app/services/submitdata/submitdata.service';
import { UtilsModule } from 'src/app/common/utils/utils.module';
import { ToastrService } from 'ngx-toastr';
import { isNullOrUndefined } from 'util';

@Component({
  selector: 'app-whats-new',
  templateUrl: './whats-new.component.html',
  styleUrls: ['./whats-new.component.css']
})
export class WhatsNewComponent implements OnInit {
  activeDisplay: any;
  // dataSource: MatTableDataSource<any>;
  @ViewChild(MatPaginator) paginator: MatPaginator;
  dataObs: Observable<any>;
  broadcastData: any;
  viewAllData: any;
  selectedYearMonth: object = { 'ay': "", "month": "" };
  yearDropDownList: any;
  monthList: any = [
    { key: '04', value: 'April' },
    { key: '05', value: 'May' },
    { key: '06', value: 'June' },
    { key: '07', value: 'July' },
    { key: '08', value: 'August' },
    { key: '09', value: 'September' },
    { key: '10', value: 'October' },
    { key: '11', value: 'November' },
    { key: '12', value: 'December' },
    { key: '01', value: 'January' },
    { key: '02', value: 'February' },
    { key: '03', value: 'March' },
  ];
  archiveData: any;
  docSubject: any = null;
  newIcon: boolean;
  hidePageSize = false;
  showNoData: boolean;
  
  constructor(
    private router: Router,
    private _changeDetectorRef: ChangeDetectorRef,
    private submitdataSerivce: SubmitdataService,
    private utils: UtilsModule,
    private toastr: ToastrService
  ) { }

  ngOnInit() {
    this.submitdataSerivce.getassesmentYear();
    this.activeDisplay = 'whatsnew';
    this.getBroadcastDocs();
    this.getdynamicYears();
    this.getCurrentMonth();
  }

  getdynamicYears() {
    let date = new Date();
    let currentYear = date.getFullYear();
    let currentmonth = date.getMonth();
    let dropDownYear;
    if (currentmonth < 3) {
      dropDownYear = (currentYear - 1) + '-' + currentYear;
    } else {
      dropDownYear = currentYear + '-' + (currentYear + 1);
    } 
    this.submitdataSerivce.getYearsToDisplay(this.submitdataSerivce.yearsPayload).subscribe(data=>{
      this.yearDropDownList = data['data'];      
    });
    this.selectedYearMonth['ay'] = dropDownYear;
  }

  getCurrentMonth() {
    let currentmonth = new Date().getMonth();
    this.monthList.forEach(monthObj => {
      if (monthObj['key'] == currentmonth + 1) {
        this.selectedYearMonth['month'] = monthObj['key'];
      }
    })
  }

  getBroadcastDocs() {
    // this.broadcastData = null;
    let postdata = {
      "pu": "ffce954d-24e1-494b-ba7e-0931d8ad6085",
      "lu": "f78f615d-e270-4f93-90ac-27608e756b85",
      // "ay": this.selectedYearMonth['ay'],
      // "subTp": this.selectedYearMonth['month'],
      "mode": "COUNT",
      "limit": 10
    }
    this.submitdataSerivce.getBroadcastDetails(postdata).subscribe(data => {
      this.broadcastData = data.data;
    })
  }

  formatTmStmp(date) {
    var datetime: any = new Date(date / 1);
    var dd = datetime.getDate();
    var mm = datetime.getMonth()+1;
    var yyyy = datetime.getFullYear();
    // var time = datetime.toLocaleTimeString();
    var fullDate = dd + '/' + mm +'/' + yyyy;   
    return fullDate;
  }

  openArchives() {
    this.activeDisplay = 'archives';

  }

  openViewall() {
    this.activeDisplay = 'viewall';
    let postdata = {
      "pu": "ffce954d-24e1-494b-ba7e-0931d8ad6085",
      "lu": "f78f615d-e270-4f93-90ac-27608e756b85",
      // "ay": this.selectedYearMonth['ay'],
      // "subTp": this.selectedYearMonth['month'],
      "mode": "ALL",
      "limit": null
    }
    this.submitdataSerivce.getBroadcastDetails(postdata).subscribe(data => {
      // this.viewAllData = data.data;
      this.setPagination(data.data);
    })
    // this.dataSource = new MatTableDataSource<object>(this.viewAllData);
  }

  setPagination(tableData) {
    this.viewAllData = new MatTableDataSource<any>(tableData);
    this._changeDetectorRef.detectChanges();
    this.viewAllData.paginator = this.paginator;
    this.dataObs = this.viewAllData.connect();
  }

  getSearchDoc() {
    if (this.docSubject == "") {
      this.docSubject = null;
    }
    let postdata = {
      "pu": "ffce954d-24e1-494b-ba7e-0931d8ad6085",
      "lu": "f78f615d-e270-4f93-90ac-27608e756b85",
      "ay": this.selectedYearMonth['ay'],
      "subTp": this.selectedYearMonth['month'],
      "keyword": this.docSubject,
      "mode": "MONTHWISE",
      "limit": null
    }
    this.submitdataSerivce.getBroadcastDetails(postdata).subscribe(data => {
      this.archiveData = data.data;
    })

    if(isNullOrUndefined(this.archiveData)){
      this.showNoData = false;
    } else{
      this.showNoData = true;
    } 
  }

  downloadDoc(fileUUID, datets) {
    let filesObj = {};
    filesObj['fileUUID'] = fileUUID;
    this.submitdataSerivce.downloadExcelDatas(filesObj).subscribe(data => {
      if (!Array.isArray(data)) {
        let fname = "Notification" + "_" + datets;
        if (data.type != "application/json") {
          switch (data.type) {
            case 'image/png': {
              fname += '.png'
              break;
            }
            case 'application/vnd.openxmlformats-officedocument.wordprocessingml.document': {
              fname += '.docx'
              break;
            }
            case "application/vnd.openxmlformats-officedocument.presentationml.presentation": {
              fname += '.pptx'
              break
            }
            case "application/vnd.openxmlformats-officedocument.presentationml.presentation": {
              fname += '.ppt'
              break
            }
            case 'application/octet-stream': {
              // fname+='.jpg'
              fname += '.pdf'
              break;
            }
            case 'application/excel': {
              fname += '.xlsx'
              break;
            }
            case 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet': {
              fname += '.xls'
              break;
            }
            case 'image/jpeg': {
              fname += '.jpeg'
              break;
            }
            case 'text/plain': {
              fname += '.txt'
              break;
            }
            case 'application/pdf': {
              fname += '.pdf'
              break;
            }
            case 'image/jpg': {
              fname += '.jpg'
              break;
            }
            default: {
              break;
            }
          }

          const fileURL = URL.createObjectURL(data)
          window.open(fileURL, '_blank')
          // this.utils.downloadFile(data, fname);
        } else {
          this.toastr.error("some exception occured")
        }

      }
    })
  }

  redirectWhatsNew() {
    this.activeDisplay = 'whatsnew';
  }

}
